/* ============================================================
   ÉTAPE 5: DOCUMENTS OBLIGATOIRES (Phase 4)
   ============================================================ */

import { RequiredDocsSelector, SelectedDoc } from '../RequiredDocsSelector';
import { SaveButton } from '../SaveButton';

interface Step5Props {
  data: any;
  onChange: (updates: any) => void;
  onSave?: () => void;
  isSaving?: boolean;
}

export function Step5RequiredDocs({ data, onChange, onSave, isSaving }: Step5Props) {
  const selectedDocs: SelectedDoc[] = data.requiredDocs || [];

  const handleDocsChange = (docs: SelectedDoc[]) => {
    onChange({ requiredDocs: docs });
  };

  return (
    <div>
      <div style={{
        padding: '1.5rem',
        background: 'linear-gradient(135deg, rgba(0,117,141,0.05) 0%, rgba(0,48,60,0.02) 100%)',
        borderRadius: '12px',
        marginBottom: '2rem',
        border: '2px solid rgba(0,117,141,0.1)',
      }}>
        <p style={{ fontSize: '0.95rem', color: '#00303c', margin: 0, lineHeight: '1.6' }}>
          Sélectionnez les documents que les clients devront téléverser lors de leur réservation. 
          Vous pouvez choisir parmi les documents prédéfinis ou ajouter des documents personnalisés.
        </p>
      </div>

      <RequiredDocsSelector
        selectedDocs={selectedDocs}
        onChange={handleDocsChange}
      />

      {/* Bouton Sauvegarder */}
      {onSave && (
        <SaveButton
          onSave={onSave}
          isSaving={isSaving || false}
        />
      )}
    </div>
  );
}
